var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container",
      style: { "--color": _vm.themeColor, "--lightColor": _vm.lightThemeColor },
    },
    [
      _c("header", { staticClass: "header" }, [
        _c("div", { staticClass: "header-div" }, [
          _c(
            "p",
            {
              on: {
                click: function ($event) {
                  _vm.isShow = !_vm.isShow
                },
              },
            },
            [_vm._v("收起搜索板")]
          ),
          _c("i", {
            class: _vm.isShow ? "el-icon-arrow-up" : "el-icon-arrow-down",
            on: {
              click: function ($event) {
                _vm.isShow = !_vm.isShow
              },
            },
          }),
        ]),
      ]),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShow,
                expression: "isShow",
              },
            ],
          },
          [
            _c("div", { staticClass: "title" }, [
              _c("div", { staticClass: "selectBox" }, [
                _c("div", { staticClass: "left" }, [
                  _c(
                    "div",
                    { staticClass: "leftLine1" },
                    [
                      _c("p", { staticClass: "p1" }, [_vm._v("分润类型：")]),
                      _c(
                        "el-button",
                        {
                          staticClass: "btns1",
                          class: _vm.init.q.type == "0" ? "active" : "",
                          staticStyle: { "margin-right": "0.06rem" },
                          attrs: { plain: "", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handlerSelectClick2("0")
                            },
                          },
                        },
                        [_vm._v("自己的子订单 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "btns1",
                          class: _vm.init.q.type == "1" ? "active" : "",
                          staticStyle: { "margin-right": "0.06rem" },
                          attrs: { plain: "", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handlerSelectClick2(1)
                            },
                          },
                        },
                        [_vm._v("客户的子订单 ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "leftLine1" },
                    [
                      _c("p", { staticClass: "p1" }, [_vm._v("产品类型：")]),
                      _c(
                        "el-button",
                        {
                          staticClass: "btns1",
                          class: _vm.init.q.state == null ? "active" : "",
                          staticStyle: { "margin-right": "0.06rem" },
                          attrs: { plain: "", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handlerSelectClick(null)
                            },
                          },
                        },
                        [_vm._v("全部 ")]
                      ),
                      _vm._l(_vm.resourceType, function (item) {
                        return _c("div", { key: item.typeName }, [
                          item.name != "交" && item.name != "服"
                            ? _c(
                                "div",
                                {
                                  staticClass: "btns",
                                  class:
                                    _vm.init.q.state === item.code
                                      ? "active"
                                      : "",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlerSelectClick(item.code)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.name) + " ")]
                              )
                            : _vm._e(),
                        ])
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "leftLine1" },
                    [
                      _c("p", { staticClass: "p1" }, [_vm._v("库存类型：")]),
                      _c("div", { staticClass: "line" }),
                      _c(
                        "el-button",
                        {
                          staticClass: "btns1",
                          class: _vm.current1 === "all" ? "active" : "",
                          staticStyle: { "margin-right": "0.06rem" },
                          attrs: { plain: "", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handlerSelectClick1("all")
                            },
                          },
                        },
                        [_vm._v("全部 ")]
                      ),
                      _vm._l(_vm.btnsList, function (item, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btns1",
                                class: _vm.current1 === item ? "active" : "",
                                staticStyle: { "margin-right": "0.06rem" },
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlerSelectClick1(item)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(item) + " ")]
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ]),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "rightBox1" }, [
                    _c(
                      "div",
                      { staticClass: "stateClBox" },
                      _vm._l(_vm.statusList, function (item) {
                        return _c(
                          "div",
                          { key: item.name, staticClass: "stateCl" },
                          [
                            _c("p", { staticClass: "p2" }, [
                              _vm._v(_vm._s(item.num)),
                            ]),
                            _c("p", { staticClass: "p3" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "rightBox2" },
                    [
                      _c("p", { staticClass: "p1" }, [_vm._v("符合条件共：")]),
                      _vm._l(_vm.userList, function (item) {
                        return _c(
                          "div",
                          { key: item.name, staticClass: "userCl" },
                          [
                            _c("p", { staticClass: "p2" }, [
                              _vm._v(" " + _vm._s(item.num) + " "),
                              _c("span", [_vm._v(_vm._s(item.currency))]),
                            ]),
                            _c("p", { staticClass: "p3" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                          ]
                        )
                      }),
                      _c("div", { staticClass: "userCl" }, [
                        _c("p", { staticClass: "p4" }, [_vm._v("清空")]),
                        _c("p", { staticClass: "p4" }, [_vm._v("筛选条件")]),
                      ]),
                    ],
                    2
                  ),
                ]),
              ]),
              _c("div", { staticClass: "selectBox1" }, [
                _c(
                  "p",
                  {
                    staticStyle: {
                      color: "#333333",
                      "font-size": "0.14rem",
                      "font-family": "SourceHanSansSC-bold",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v(" 订单状态： ")]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      flex: "1",
                      display: "flex",
                      "justify-content": "space-between",
                    },
                  },
                  _vm._l(_vm.stepList, function (item, keys) {
                    return _c(
                      "div",
                      { key: keys, staticClass: "stepBox" },
                      [
                        _c("p", { staticClass: "p1" }, [_vm._v(_vm._s(keys))]),
                        _vm._l(item, function (item1, index) {
                          return _c("el-checkbox", {
                            key: index,
                            staticClass: "checkbox",
                            staticStyle: { "margin-bottom": "0.1rem" },
                            attrs: { label: item1.name, size: "small" },
                            on: {
                              change: function ($event) {
                                return _vm.selectStateChange(item1)
                              },
                            },
                          })
                        }),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]),
              _c("div", { staticClass: "selectBox2" }, [
                _c("div", { staticClass: "right" }, [
                  _c(
                    "div",
                    { staticClass: "rightLine1" },
                    [
                      _c("p", { staticClass: "p1" }, [_vm._v("查询关键词")]),
                      _c(
                        "el-select",
                        {
                          staticStyle: {
                            "margin-right": "0.1rem",
                            width: "1.5rem",
                          },
                          attrs: { placeholder: "请选择", size: "small" },
                          model: {
                            value: _vm.value,
                            callback: function ($$v) {
                              _vm.value = $$v
                            },
                            expression: "value",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                      _c("el-input", {
                        staticStyle: {
                          width: "1.5rem",
                          "margin-right": "0.1rem",
                        },
                        attrs: {
                          clearable: "",
                          placeholder: "订单编号",
                          size: "small",
                        },
                        model: {
                          value: _vm.init.q.childrenIds[0],
                          callback: function ($$v) {
                            _vm.$set(_vm.init.q.childrenIds, 0, $$v)
                          },
                          expression: "init.q.childrenIds[0]",
                        },
                      }),
                      _c("el-input", {
                        staticStyle: {
                          width: "1.1rem",
                          "margin-right": "0.1rem",
                        },
                        attrs: {
                          clearable: "",
                          placeholder: "团号",
                          size: "small",
                        },
                        model: {
                          value: _vm.init.q.planId,
                          callback: function ($$v) {
                            _vm.$set(_vm.init.q, "planId", $$v)
                          },
                          expression: "init.q.planId",
                        },
                      }),
                      _c("el-input", {
                        staticStyle: {
                          width: "1.1rem",
                          "margin-right": "0.1rem",
                        },
                        attrs: {
                          clearable: "",
                          placeholder: "询单号",
                          size: "small",
                        },
                      }),
                      _c("el-input", {
                        staticStyle: {
                          width: "1.2rem",
                          "margin-right": "0.1rem",
                        },
                        attrs: {
                          clearable: "",
                          placeholder: "资源名称",
                          size: "small",
                        },
                        model: {
                          value: _vm.init.q.resourceNameKey,
                          callback: function ($$v) {
                            _vm.$set(_vm.init.q, "resourceNameKey", $$v)
                          },
                          expression: "init.q.resourceNameKey",
                        },
                      }),
                      _c("el-input", {
                        staticStyle: {
                          width: "1rem",
                          "margin-right": "0.1rem",
                        },
                        attrs: { placeholder: "下单人", size: "small" },
                        model: {
                          value: _vm.init.q.createName,
                          callback: function ($$v) {
                            _vm.$set(_vm.init.q, "createName", $$v)
                          },
                          expression: "init.q.createName",
                        },
                      }),
                      _c("el-input", {
                        staticStyle: {
                          width: "1.5rem",
                          "margin-right": "0.1rem",
                        },
                        attrs: {
                          clearable: "",
                          placeholder: "分润用户账号",
                          size: "small",
                        },
                      }),
                      _c("el-input", {
                        staticStyle: {
                          width: "1.8rem",
                          "margin-right": "0.1rem",
                        },
                        attrs: {
                          clearable: "",
                          placeholder: "用户公司名称/账号",
                          size: "small",
                        },
                      }),
                      _c("el-input", {
                        staticStyle: {
                          width: "1.5rem",
                          "margin-right": "0.1rem",
                        },
                        attrs: {
                          clearable: "",
                          placeholder: "国家/城市",
                          size: "small",
                        },
                      }),
                      _c("el-input", {
                        staticStyle: {
                          width: "1.1rem",
                          "margin-right": "0.1rem",
                        },
                        attrs: {
                          clearable: "",
                          placeholder: "库存商品",
                          size: "small",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "rightLine2" },
                    [
                      _c("p", { staticClass: "p1" }, [_vm._v("时间")]),
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { "margin-right": "0.05rem" },
                          attrs: { size: "small" },
                          on: {
                            change: function ($event) {
                              ;(_vm.init.page = 1),
                                (_vm.orderSelectedData = []),
                                _vm.orderList()
                            },
                          },
                          model: {
                            value: _vm.init.q.timeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.init.q, "timeType", $$v)
                            },
                            expression: "init.q.timeType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("下单日期"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("付款日期"),
                          ]),
                          _c("el-radio", { attrs: { label: 3 } }, [
                            _vm._v("使用日期"),
                          ]),
                        ],
                        1
                      ),
                      _c("el-date-picker", {
                        staticStyle: { "margin-right": "0.1rem" },
                        attrs: {
                          "end-placeholder": "结束日期",
                          "range-separator": "至",
                          size: "small",
                          "start-placeholder": "开始日期",
                          type: "daterange",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { change: _vm.handlerSelectDate },
                        model: {
                          value: _vm.dateArr,
                          callback: function ($$v) {
                            _vm.dateArr = $$v
                          },
                          expression: "dateArr",
                        },
                      }),
                      _c("p", { staticClass: "p1" }, [_vm._v("金额")]),
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { "margin-right": "0.1rem" },
                          attrs: { size: "small" },
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { label: 3 } },
                            [
                              _c(
                                "span",
                                { staticStyle: { "margin-right": "0.05rem" } },
                                [_vm._v("大于等于")]
                              ),
                              _c("el-input", {
                                staticStyle: {
                                  width: "0.7rem",
                                  "margin-right": "0.05rem",
                                },
                                attrs: { size: "small" },
                              }),
                              _c("span", [_vm._v("¥")]),
                            ],
                            1
                          ),
                          _c(
                            "el-radio",
                            { attrs: { label: 9 } },
                            [
                              _c(
                                "span",
                                { staticStyle: { "margin-right": "0.05rem" } },
                                [_vm._v("小于等于")]
                              ),
                              _c("el-input", {
                                staticStyle: {
                                  width: "0.7rem",
                                  "margin-right": "0.05rem",
                                },
                                attrs: { size: "small" },
                              }),
                              _c("span", [_vm._v("¥")]),
                            ],
                            1
                          ),
                          _c(
                            "el-radio",
                            { attrs: { label: 6 } },
                            [
                              _c("el-input", {
                                staticStyle: {
                                  width: "0.7rem",
                                  "margin-right": "0.05rem",
                                },
                                attrs: { size: "small" },
                              }),
                              _c("span", [_vm._v("¥")]),
                              _c(
                                "span",
                                { staticStyle: { "margin-right": "0.06rem" } },
                                [_vm._v("至")]
                              ),
                              _c("el-input", {
                                staticStyle: {
                                  width: "0.7rem",
                                  "margin-right": "0.05rem",
                                },
                                attrs: { size: "small" },
                              }),
                              _c(
                                "span",
                                { staticStyle: { "margin-right": "0.05rem" } },
                                [_vm._v("¥")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-right": "0.05rem" },
                          attrs: {
                            checked: Boolean(_vm.init.q.includesToBeConfirmed),
                          },
                          on: { change: _vm.resChange },
                        },
                        [_vm._v("待选的资源 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "", size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              ;(_vm.init.page = 1),
                                (_vm.init.q.childrenIds =
                                  _vm.init.q.childrenIds.filter((n) => n)),
                                (_vm.orderSelectedData = []),
                                _vm.orderList()
                            },
                          },
                        },
                        [_vm._v("搜索 ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      _c("div", { staticClass: "tablerCl" }, [
        _c("div", { staticClass: "topLine" }, [
          _c(
            "p",
            { staticClass: "p1" },
            [
              _vm._v("数据列表 "),
              _c(
                "el-tag",
                {
                  staticStyle: { "margin-left": "0.1rem" },
                  attrs: { effect: "dark", type: "danger" },
                },
                [
                  _vm._v(
                    " 勾选商品总计人民币：" + _vm._s(_vm.checkTheAmount) + "¥ "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btnBox" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "0.1rem" },
                  attrs: { plain: "", size: "small", type: "primary" },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("staticTable", {
        attrs: {
          dataType: _vm.init.q.type,
          loading: _vm.loading,
          tableData: _vm.listDatas,
        },
        on: {
          openModifyPopup: _vm.openModifyPopup,
          openPay: _vm.openPay,
          openStockpopup: _vm.openStockpopup,
          orderSelect: _vm.orderSelect,
          updateList: _vm.updateList,
        },
      }),
      _c("Pagination", {
        attrs: {
          currentPage: _vm.init.page,
          pageSizes: _vm.pageSizes,
          parentPageSize: 10,
          totalNumber: _vm.AllpagesNum,
        },
        on: { loadTable: _vm.loadTable },
      }),
      _c("stockPopup", {
        ref: "stockPopup",
        on: { openPay: _vm.openPay, updateList: _vm.updateList },
      }),
      _c("stockPay", {
        ref: "stockPay",
        attrs: {
          dataMap: _vm.payData.dataMap,
          orderChildrenIds: _vm.payData.orderChildrenIds,
          orderMainId: _vm.payData.orderMainId,
          payMoney: _vm.payData.payMoney,
        },
        on: {
          payUpload: function ($event) {
            return _vm.$refs.PaymentPricePopup.close()
          },
        },
      }),
      _c("PaymentPricePopup", {
        ref: "PaymentPricePopup",
        on: { payOrder: _vm.payOrder },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }